module.exports = __webpack_public_path__ + "img/img_phone_2.4f30f9c3.webp";